import React from "react";
import Contact from "../Components/Contact/Contact";
import Accordion from "../Components/Accordion/Accordion";
import Funfact from "../Components/Funfact/Funfact";
import Hero from "../Components/Hero/Hero";

const heroData = {
  bgImg: "images/hero-bg9.jpg",

  title: [
    "Complaints.",
    "Security Policies.",
    "Data Protection.",
    "Account Management.",
    "Help Center.",
  ],
};

const faqData = {
  title: "FAQs",
  img: "images/faq.png",
  bgImg: "shape/faq-bg.svg",
  faqItems: [
    {
      title: "Can I delete my account? How do I request account deletion?",
      content: `Yes, you can request account deletion by navigating to Support → Contact Us within the app or by emailing support@dotor.org. Once your request is processed, all associated data will be permanently removed.`,
    },
    {
      title: " What are the Terms of Use for the Dotor Anjana Community app?",
      content: `The Terms of Use outline the rules for using our app, including acceptable behavior, content guidelines, and user responsibilities. By using the app, you agree to comply with these terms to maintain a safe and respectful community.`,
    },
    {
      title:
        "How does the Dotor Anjana Community ensure user privacy and data security?",
      content: `We manually verify each registration to prevent fake profiles. Your personal data is securely stored and is not shared with third parties, except as required by law. You can review our full Privacy Policy for details on data collection and protection.`,
    },
    {
      title: "What happens if a user violates the Terms & Conditions?",
      content: `If a user violates our community guidelines (e.g., sharing harmful content, harassment), our support team will take appropriate action, including content removal or account suspension. Users can also report concerns via the in-app Support → Contact Us feature.`,
    },
    {
      title: "How often are the Terms & Conditions and Privacy Policy updated?",
      content: `We update our Terms & Conditions and Privacy Policy as needed to comply with regulations and improve user experience. Any changes will be communicated within the app, and continued use signifies acceptance of the latest terms.`,
    },
  ],
};

const Home = () => {
  return (
    <>
      <Hero data={heroData} />
      <Contact />
      <Funfact />
      <Accordion data={faqData} />
    </>
  );
};

export default Home;
